import { render, staticRenderFns } from "./scale-out-component.vue?vue&type=template&id=0ad5b4dd&scoped=true&"
import script from "./scale-out-component.vue?vue&type=script&lang=js&"
export * from "./scale-out-component.vue?vue&type=script&lang=js&"
import style0 from "./scale-out-component.vue?vue&type=style&index=0&id=0ad5b4dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5b4dd",
  null
  
)

export default component.exports